// Recursively strip `undefined` values from an object/array tree so it is safe
// to write to Firestore, which rejects `undefined` anywhere in the payload
// (`Unsupported field value: undefined`). Undefined object properties and
// undefined array elements are removed; all other values (including `null`,
// `NaN`, Date, and empty string) are preserved. Non-plain objects such as
// Date, Timestamp, and FieldValue (serverTimestamp) are returned untouched.
const isPlainObject = (value) =>
  value !== null &&
  typeof value === 'object' &&
  (value.constructor === Object || Object.getPrototypeOf(value) === null);

export const sanitizeForFirestore = (input) => {
  if (Array.isArray(input)) {
    return input.filter((item) => item !== undefined).map((item) => sanitizeForFirestore(item));
  }

  if (isPlainObject(input)) {
    const output = {};
    Object.entries(input).forEach(([key, value]) => {
      if (value === undefined) return;
      output[key] = sanitizeForFirestore(value);
    });
    return output;
  }

  return input;
};
